<div class="container">
  <h1>Please verify your email</h1>
  <p>
    We’ve sent a verification link to your email. You need to verify your email
    address before you can continue.
  </p>
  <p>
    If you haven’t received the email, please check your spam folder or get in
    touch with support.
  </p>
  <div class="actions">
    <button
      pButton
      type="button"
      label="Back to Login"
      (click)="logout()"
    ></button>
  </div>
</div>
